import $ from 'jquery';
import Framework from 'framework';
import Cookies from 'cookies-js';
import urlUtils from 'lib/url-utils';
import constants from 'lib/constants';

// multi-use reference constants
// id constants
const CORP_MEMBERSHIP_DISPLAY_CONTAINER_ID = '#corpMembershipHeader';

// class constants

// element reference constants
const CORP_MEMBERSHIP_ELEMENT = $('#corporateMembership');
const CORP_DISPLAY_NAME_ELEMENT = $('.corp-display-name');
const CORP_DYNAMIC_CONTENT_ELEMENT = $('.dynamic-corp-content');
const CORP_MEMBERSHIP_ERROR_ELEMENT = $('#corporateMembershipError');
const CORP_MEMBERSHIP_DISPLAY_CONTAINER_ELEMENT = $(CORP_MEMBERSHIP_DISPLAY_CONTAINER_ID);

const corpDisplayNameCookieDuration = 2592000; // 30 days

function storePromotionInformation(promotionName, displayName) {
	Cookies.set(constants.cookieCorpMembership, promotionName + '|' + displayName, {domain: '.lifetime.life', expires: 0});
}

$(document).on('ready', ()=> {
	// check if we are on the corporate memberships page and not on author
	if(CORP_MEMBERSHIP_ELEMENT.length > 0 && window.location.href.indexOf('author') <= 0) {
		const promotionName = urlUtils.getUrlParameter('promotionName');
		if(promotionName !== null && promotionName.length > 0) {
			$(document).on('display-name', (event, obj)=> {
				if(obj.displayName) {
					storePromotionInformation(promotionName, obj.displayName);
					CORP_DISPLAY_NAME_ELEMENT.text(obj.displayName);
					CORP_MEMBERSHIP_ERROR_ELEMENT.remove();
					CORP_MEMBERSHIP_DISPLAY_CONTAINER_ELEMENT.removeClass(constants.loadingSpinnerLgString);
					$(CORP_MEMBERSHIP_DISPLAY_CONTAINER_ID + ' p').removeClass(constants.hiddenXsUpString);
				} else{
					if(obj.error.errorType === 'corporateSaleNotFound') {
						window.location.href = Framework.global.lt.globalPageDrivers.global.corpMembershipError;
					} else{
						CORP_MEMBERSHIP_ELEMENT.remove();
						CORP_DYNAMIC_CONTENT_ELEMENT.remove();
						CORP_MEMBERSHIP_ERROR_ELEMENT.removeClass(constants.hiddenXsUpString);
					}
				}
			});
		} else{
			window.location.href = Framework.global.lt.globalPageDrivers.global.corpMembershipError;
		}
	}
});
